import GumAnalytics from "./GumAnalytics";
const gumAnalytics = new GumAnalytics({ projectId: "" });

export { GumAnalytics };
export default gumAnalytics;